"use strict";
/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _regeneratorRuntime = require("/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/professor/WebstormProjects/string_table_converter/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
}); // This file implements crypto functions we need using in-browser
// SubtleCrypto interface `window.crypto.subtle`.

var base64js = require("base64-js");

var isbrowser_1 = require("../../isbrowser"); // Not all browsers support `TextEncoder`. The following `require` will
// provide a fast UTF8-only replacement for those browsers that don't support
// text encoding natively.


if (isbrowser_1.isBrowser() && typeof TextEncoder === 'undefined') {
  require('fast-text-encoding');
}

var BrowserCrypto =
/*#__PURE__*/
function () {
  function BrowserCrypto() {
    _classCallCheck(this, BrowserCrypto);

    if (typeof window === 'undefined' || window.crypto === undefined || window.crypto.subtle === undefined) {
      throw new Error("SubtleCrypto not found. Make sure it's an https:// website.");
    }
  }

  _createClass(BrowserCrypto, [{
    key: "sha256DigestBase64",
    value: function () {
      var _sha256DigestBase = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee(str) {
        var inputBuffer, outputBuffer;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                // SubtleCrypto digest() method is async, so we must make
                // this method async as well.
                // To calculate SHA256 digest using SubtleCrypto, we first
                // need to convert an input string to an ArrayBuffer:
                inputBuffer = new TextEncoder().encode(str); // Result is ArrayBuffer as well.

                _context.next = 3;
                return window.crypto.subtle.digest('SHA-256', inputBuffer);

              case 3:
                outputBuffer = _context.sent;
                return _context.abrupt("return", base64js.fromByteArray(new Uint8Array(outputBuffer)));

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function sha256DigestBase64(_x) {
        return _sha256DigestBase.apply(this, arguments);
      }

      return sha256DigestBase64;
    }()
  }, {
    key: "randomBytesBase64",
    value: function randomBytesBase64(count) {
      var array = new Uint8Array(count);
      window.crypto.getRandomValues(array);
      return base64js.fromByteArray(array);
    }
  }, {
    key: "verify",
    value: function () {
      var _verify = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(pubkey, data, signature) {
        var algo, dataArray, signatureArray, cryptoKey, result;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                algo = {
                  name: 'RSASSA-PKCS1-v1_5',
                  hash: {
                    name: 'SHA-256'
                  }
                };
                dataArray = new TextEncoder().encode(data); // base64js requires padding, so let's add some '='

                while (signature.length % 4 !== 0) {
                  signature += '=';
                }

                signatureArray = base64js.toByteArray(signature);
                _context2.next = 6;
                return window.crypto.subtle.importKey('jwk', pubkey, algo, true, ['verify']);

              case 6:
                cryptoKey = _context2.sent;
                _context2.next = 9;
                return window.crypto.subtle.verify(algo, cryptoKey, signatureArray, dataArray);

              case 9:
                result = _context2.sent;
                return _context2.abrupt("return", result);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      function verify(_x2, _x3, _x4) {
        return _verify.apply(this, arguments);
      }

      return verify;
    }()
  }, {
    key: "createSign",
    value: function createSign(algorithm) {
      throw new Error('createSign is not implemented in BrowserCrypto');
    }
  }, {
    key: "decodeBase64StringUtf8",
    value: function decodeBase64StringUtf8(base64) {
      var uint8array = base64js.toByteArray(base64);
      var result = new TextDecoder().decode(uint8array);
      return result;
    }
  }, {
    key: "encodeBase64StringUtf8",
    value: function encodeBase64StringUtf8(text) {
      var uint8array = new TextEncoder().encode(text);
      var result = base64js.fromByteArray(uint8array);
      return result;
    }
  }]);

  return BrowserCrypto;
}();

exports.BrowserCrypto = BrowserCrypto;